export default __webpack_public_path__ + "static/media/imgpost9.5f98bf61.jpg";